import * as React from "react";
import * as ReactDOM from "react-dom";
import { differenceInMinutes, format } from "date-fns";
import * as ru from "date-fns/locale/ru";
import classnames from "classnames";
import Tooltip from "rc-tooltip";
import { tl } from "../../utils";
import * as styles from "./styles.scss";

import {
  Card,
  Switch,
  List,
  Star,
  Input,
  Button,
  Form,
  Popup,
  Badge,
  Icon,
  DateDiff,
} from "../../components";
import { getDateHMDiff } from "../../utils";
import { themeVariables } from "../../entryes/panel/MUI";

interface IProps {
  style?: "danger" | "success";
  fullname: string;
  startDate: any;
  endDate: any;
  avatar: string;
  count?: any;
  isCompleted?: boolean;
  isHidden?: boolean;
  datePrefix?: string;
  onCut?: any;
  profileUrl?: string;
  pmUrl?: string;
  status?: any;
}

export class ListItemCommentCut extends React.Component<IProps, {}> {
  render() {
    const {
      style,
      avatar,
      fullname,
      children,
      startDate,
      endDate,
      count,
      datePrefix,
      isHidden,
      onCut,
      status,
      profileUrl,
      pmUrl,
    } = this.props;

    const className = {
      date: classnames({
        [styles.date]: true,
      }),
    };

    const dateFormat = "DD.MM.YYYY HH:mm";
    const { hours, minutes } = getDateHMDiff(startDate, endDate);
    const date = `${hours ? `${hours}ч. ` : ""}${minutes}м.`;
    const cutText = isHidden ? tl("Развернуть") : tl("Свернуть");

    return (
      <List.Item type={style} cutter>
        <div
          className={styles.commentCut}
          style={{ borderTop: themeVariables.border }}
        >
          {avatar ? (
            <div className={styles.avatarItem}>
              <div
                className={styles.avatar}
                style={avatar ? { backgroundImage: `url(${avatar})` } : null}
              />
            </div>
          ) : null}

          <span
            className={styles.fullname}
            style={{
              color: themeVariables.palette.primary.dark,
            }}
          >
            <span className="atpopover-trigger">
              {fullname}
              <span className="atpopover left">
                <ul>
                  <li>
                    <a href={profileUrl} target="_blank">
                      Профиль
                    </a>
                  </li>
                  <li>
                    <a href={pmUrl} target="_blank">
                      Чат
                    </a>
                  </li>
                </ul>
              </span>
            </span>
          </span>

          <span className={styles.dateWrapper}>
            <div
              className={className.date}
              title={`Начало: ${format(startDate, dateFormat)}
Конец: ${format(endDate, dateFormat)}`}
            >
              <div>
                {datePrefix}
                <DateDiff from={endDate} to={startDate} />
              </div>
              <div>{`${tl("Проверка от")} ${format(endDate, dateFormat)}`}</div>
            </div>
          </span>

          {this.props.onCut !== undefined ? (
            <div
              className={styles.cut}
              onClick={onCut}
              style={{
                color: themeVariables.palette.primary.main,
              }}
            >
              {cutText}{" "}
              {count > 0 && isHidden ? `(${count})` : ""}
            </div>
          ) : null}
        </div>
      </List.Item>
    );
  }
}
